import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

export type StepStatus = 'completed' | 'inprogress';

@Component({
    selector: 'mpro-wizard-step',
    template: '<ng-template><ng-content></ng-content></ng-template>'
})
export class WizardStepComponent {
    @ViewChild(TemplateRef)
    public content: TemplateRef<any>;
    @Input()
    public label: string;
    @Input()
    public nextStepDisabled: boolean = false;
    public status: StepStatus = 'inprogress';
}